import React, { useState, useEffect } from 'react';
import { Spin, message, Table } from 'antd';
import { estadisticahurto, poblacionVictima, resultados_operativos, seguridad_ciudadana, violenciaGenero } from '../../../services/perfiles/conponentesServices';
import './tablaG.css';

const SeguridadCiudadana = ({ municipioId }) => {
    const [loading, setLoading] = useState(false);
    const [seguridadData, setSeguridadData] = useState([]);
    const [poblacionData, setPoblacionData] = useState([]);
    const [hurtoData, setHurtoData] = useState(null); // Cambiado a null para manejar el estado inicial
    const [resultadosOperativosData, setResultadosOperativosData] = useState(null); // Estado para los resultados operativos
    const [violenciaGeneroData, setViolenciaGeneroData] = useState(null); // Estado para la violencia de género
    useEffect(() => {
        if (municipioId) {
            fetchSeguridadData();
            fetchPoblacionData();
            fetchHurtoData();
            fetchViolenciaGeneroData(); // Llamada a la nueva función
            fetchResultadosOperativosData()
        }
    }, [municipioId]);

    const fetchSeguridadData = async () => {
        setLoading(true);
        try {
            const response = await seguridad_ciudadana(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                setSeguridadData(fetchedData);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchPoblacionData = async () => {
        setLoading(true);
        try {
            const response = await poblacionVictima(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data;
                setPoblacionData(fetchedData);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchHurtoData = async () => {
        setLoading(true);
        try {
            const response = await estadisticahurto(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data[0]; // Ajuste aquí para obtener el primer objeto del array
                setHurtoData(fetchedData);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchResultadosOperativosData = async () => {
        setLoading(true);
        try {
            const response = await resultados_operativos(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data[0]; // Ajuste aquí para obtener el primer objeto del array
                setResultadosOperativosData(fetchedData);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const fetchViolenciaGeneroData = async () => {
        setLoading(true);
        try {
            const response = await violenciaGenero(municipioId);
            if (response && response.status === 200) {
                const fetchedData = response.data[0]; // Ajuste aquí para obtener el primer objeto del array
                setViolenciaGeneroData(fetchedData);
            } else {
                throw new Error('Invalid response from server');
            }
        } catch (error) {
            message.error('Error loading data');
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const seguridadColumns = [
        { title: 'Campo', dataIndex: 'campo', key: 'campo' },
        { title: 'Valor Directo', dataIndex: 'valor_directo', key: 'valor_directo' },
        { title: 'Valor Indirecto', dataIndex: 'valor_indirecto', key: 'valor_indirecto' },
    ];

    const seguridadTableData = seguridadData.map(item => ([
        { campo: 'Desaparición', valor_directo: item.desaparicion_directa, valor_indirecto: item.desaparicion_indirecta },
        { campo: 'Homicidio', valor_directo: item.homicidio_directo, valor_indirecto: item.homicidio_indirecto },
        { campo: 'Secuestro', valor_directo: item.secuestro_directo, valor_indirecto: item.secuestro_indirecto },
    ])).flat();
    const violenciaGeneroColumns = [
        { title: 'Violencia Basada en Género - 2021', dataIndex: 'tipo', key: 'tipo' },
        { title: 'HOMBRE', dataIndex: 'hombre', key: 'hombre' },
        { title: 'MUJER', dataIndex: 'mujer', key: 'mujer' },
    ];
    const poblacionColumns = [
        { title: 'Hecho Victimizante', dataIndex: 'nombre', key: 'nombre' },
        { title: 'Víctimas Ocurrencia', dataIndex: 'victimas_ocurrencia', key: 'victimas_ocurrencia' },
        { title: 'Víctimas Declaración', dataIndex: 'victima_declaracion', key: 'victima_declaracion' },
        { title: 'Víctimas de Ubicación', dataIndex: 'victimas_ubicacion', key: 'victimas_ubicacion' },
        { title: 'Sujetos de Atención', dataIndex: 'sujetos_atencion', key: 'sujetos_atencion' },
        { title: 'Eventos', dataIndex: 'eventos', key: 'eventos' },
    ];

    const hurtoColumns = [
        { title: 'Clase de Hurto', dataIndex: 'clase_hurto', key: 'clase_hurto' },
        { title: 'Total', dataIndex: 'total', key: 'total' },
    ];

    const hurtoTableData = hurtoData ? [
        { clase_hurto: 'Hurto a personas', total: hurtoData.hurto_personas },
        { clase_hurto: 'Hurto a comercio', total: hurtoData.hurto_comercio },
        { clase_hurto: 'Hurto a residencias', total: hurtoData.hurto_residencias },
        { clase_hurto: 'Hurto de automotores', total: hurtoData.hurto_automotores },
        { clase_hurto: 'Hurto de motocicletas', total: hurtoData.hurto_motocicletas },
    ] : [];

    const resultadosOperativosColumns = [
        { title: 'Operativos Realizados', dataIndex: 'operativos_realizados', key: 'operativos_realizados' },
        { title: 'Total (KG)', dataIndex: 'total_kg', key: 'total_kg' },
    ];

    const resultadosOperativosTableData = resultadosOperativosData ? [
        { operativos_realizados: 'Capturas', total_kg: resultadosOperativosData.capturas },
        { operativos_realizados: 'Incautaciones de Estupefacientes', total_kg: resultadosOperativosData.incautaciones_estupefacientes },
        { operativos_realizados: 'Incautaciones de Armas', total_kg: resultadosOperativosData.incautaciones_armas },
        { operativos_realizados: 'Recuperación de Vehículos', total_kg: resultadosOperativosData.recuperacion_vehiculos },
        { operativos_realizados: 'Recuperación de Motos', total_kg: resultadosOperativosData.recuperacion_motos },
    ] : [];
    const violenciaGeneroTableData = violenciaGeneroData ? [
        { tipo: 'Homicidio', hombre: violenciaGeneroData.homicidio_hombre, mujer: violenciaGeneroData.homicidio_mujer },
        { tipo: 'Exámenes Médico Legales', hombre: violenciaGeneroData.examenes_hombre, mujer: violenciaGeneroData.examenes_mujer },
        { tipo: 'Violencia de Pareja', hombre: violenciaGeneroData.violencia_pareja_hombre, mujer: violenciaGeneroData.violencia_pareja_mujer },
        { tipo: 'Violencia Intrafamiliar', hombre: violenciaGeneroData.violencia_intrafamiliar_hombre, mujer: violenciaGeneroData.violencia_intrafamiliar_mujer },
        { tipo: 'Suicidio', hombre: violenciaGeneroData.suicidio_hombre, mujer: violenciaGeneroData.suicidio_mujer },
        { tipo: 'Total Víctimas', hombre: violenciaGeneroData.total_victimas_hombre, mujer: violenciaGeneroData.total_victimas_mujer },
    ] : [];
    return (
        <div>
            <h1>6. SEGURIDAD CIUDADANA</h1>
            {poblacionData.length > 0 ? (
                <Table
                    columns={poblacionColumns}
                    dataSource={poblacionData}
                    rowKey="id_poblacion"
                    loading={loading}
                    pagination={{ pageSize: 7 }}
                />
            ) : (
                <p>No hay datos disponibles para el municipio</p>
            )}
            {seguridadTableData.length > 0 ? (
                <Table
                    columns={seguridadColumns}
                    dataSource={seguridadTableData}
                    rowKey={(record) => `${record.campo}-${record.valor_directo}`}
                    loading={loading}
                    pagination={false}
                    footer={() => `Fuente: ${seguridadData.fuente || 'No disponible'}`}
                />
            ) : (
                <p>No hay datos disponibles para el municipio</p>
            )}
            {hurtoData ? (
                <Table
                    columns={hurtoColumns}
                    dataSource={hurtoTableData}
                    rowKey={(record) => `${record.clase_hurto}-${record.total}`}
                    loading={loading}
                    pagination={false}
                    footer={() => `Fuente: ${hurtoData.fuente || 'No disponible'}`}
                />
            ) : (
                <p>No hay datos disponibles para el municipio</p>
            )}
            {resultadosOperativosData ? (
                <Table
                    columns={resultadosOperativosColumns}
                    dataSource={resultadosOperativosTableData}
                    rowKey={(record) => `${record.operativos_realizados}-${record.total_kg}`}
                    loading={loading}
                    pagination={false}
                    footer={() => `Fuente: ${resultadosOperativosData.fuente || 'No disponible'}`}
                />
            ) : (
                <p>No hay datos disponibles para el municipio</p>
            )}
            {violenciaGeneroData ? (
                <Table
                    columns={violenciaGeneroColumns}
                    dataSource={violenciaGeneroTableData}
                    rowKey={(record) => `${record.tipo}-${record.hombre}-${record.mujer}`}
                    loading={loading}
                    pagination={false}
                    footer={() => `Fuente: ${violenciaGeneroData.fuente || 'No disponible'}`}
                />
            ) : (
                <p>No hay datos disponibles para el municipio</p>
            )}
        </div>
    );
};

export default SeguridadCiudadana;
